'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.rootSaga = rootSaga;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

var _notifications = require('./notifications');

var _notifications2 = _interopRequireDefault(_notifications);

var _modals = require('./modals');

var _modals2 = _interopRequireDefault(_modals);

var _processesQueue = require('./processesQueue');

var _processesQueue2 = _interopRequireDefault(_processesQueue);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _rules = require('./rules');

var _rules2 = _interopRequireDefault(_rules);

var _errors = require('./errors');

var _errors2 = _interopRequireDefault(_errors);

var _templates = require('./templates');

var _templates2 = _interopRequireDefault(_templates);

var _GenericSettings = require('./GenericSettings');

var _GenericSettings2 = _interopRequireDefault(_GenericSettings);

var _oldCFA = require('./GenericSettings/oldCFA');

var _unauthorized = require('./unauthorized');

var _rendering = require('./rendering');

var _rendering2 = _interopRequireDefault(_rendering);

var _timedLogout = require('./timedLogout.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga);

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  app: _app2.default,
  notifications: _notifications2.default,
  modals: _modals2.default,
  processesQueue: _processesQueue2.default,
  templateApplication: _templates2.default,
  genericSettings: _GenericSettings2.default,
  rendering: _rendering2.default,
  auth: _auth2.default,
  rules: _rules2.default,
  errors: _errors2.default
});

/* SAGA
 * ---------------------------------------------------------------------------------------------- */

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.fork)(_templates.watchGetTemplates);

        case 2:
          _context.next = 4;
          return (0, _effects.fork)(_templates.watchGetTemplate);

        case 4:
          _context.next = 6;
          return (0, _effects.fork)(_templates.watchGetTemplatesSettings);

        case 6:
          _context.next = 8;
          return (0, _effects.fork)(_templates.watchSaveTemplate);

        case 8:
          _context.next = 10;
          return (0, _effects.fork)(_templates.watchSetCurrentTemplate);

        case 10:
          _context.next = 12;
          return (0, _effects.fork)(_GenericSettings.watchGetGenericSettings);

        case 12:
          _context.next = 14;
          return (0, _effects.fork)(_GenericSettings.watchSaveGenericSettings);

        case 14:
          _context.next = 16;
          return (0, _effects.fork)(_GenericSettings.watchGetStorageOptions);

        case 16:
          _context.next = 18;
          return (0, _effects.fork)(_processesQueue.watchForProcesses);

        case 18:
          _context.next = 20;
          return (0, _effects.fork)(_templates.watchSaveTemplateApplicationSettings);

        case 20:
          _context.next = 22;
          return (0, _effects.fork)(_templates.watchCloneTemplate);

        case 22:
          _context.next = 24;
          return (0, _effects.fork)(_templates.watchCancelTemplateConfiguration);

        case 24:
          _context.next = 26;
          return (0, _effects.fork)(_auth.watchFecthLoginSaga);

        case 26:
          _context.next = 28;
          return (0, _effects.fork)(_auth.watchLogoutSaga);

        case 28:
          _context.next = 30;
          return (0, _effects.fork)(_rules.watchFecthGetRulesSaga);

        case 30:
          _context.next = 32;
          return (0, _effects.fork)(_rules.watchSendRulesSaga);

        case 32:
          _context.next = 34;
          return (0, _effects.fork)(_auth.watchAfterLogoutSaga);

        case 34:
          _context.next = 36;
          return (0, _effects.fork)(_templates.watchDeleteTemplateConfigurationSaga);

        case 36:
          _context.next = 38;
          return (0, _effects.fork)(_unauthorized.watchHandleUnauthorizedRequest);

        case 38:
          _context.next = 40;
          return (0, _effects.fork)(_GenericSettings.watchGetConfiguration);

        case 40:
          _context.next = 42;
          return (0, _effects.fork)(_GenericSettings.watchSaveConfiguration);

        case 42:
          _context.next = 44;
          return (0, _effects.fork)(_oldCFA.oldCFAwatchers);

        case 44:
          _context.next = 46;
          return (0, _effects.fork)(_timedLogout.watchActivityListener);

        case 46:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/root.js
// module id = 667
// module chunks = 0